import { SimpleForm as RaSimpleForm, SimpleFormProps } from 'react-admin';
import { ComponentType } from 'react';
import Toolbar from './Toolbar';
import { mergeSx } from '../../utils';
import { Unstable_Grid2 as Grid } from '@mui/material';

const toolbar = <Toolbar />;
const SimpleForm: ComponentType<SimpleFormProps> = (props) => {
    return (
        <RaSimpleForm
            toolbar={toolbar}
            {...props}
            sx={[
                {
                    p: {
                        xs: 2,
                        md: 4,
                    },

                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                },
                ...mergeSx(props.sx),
            ]}
        >
            <Grid container>
                <Grid xs={12} lg={8}>
                    {props.children}
                </Grid>
            </Grid>
        </RaSimpleForm>
    );
};

export default SimpleForm;
